module.exports = __webpack_public_path__ + "svg/illustration-business-call-reverse.35430d4.svg";